import React from 'react';
import { Query, Mutation } from '@apollo/react-components';
import { Adopt } from 'react-adopt';
import {
  FETCH_SUBSCRIPTION_PAYMENTS,
  FETCH_PAYMENTS_DUE,
  CREATE_USER_PAYMENT,
} from './queries';
import { mapSubscriptions, mapPaymentsDue } from './mapping';
import { notify, messages, pagination } from '../../utils';
import PaymentsScreen from '../../screens/PaymentsScreen';

const mapper = {
  /* eslint-disable react/prop-types */
  subscriptions: ({ render }) => (
    <Query
      query={FETCH_SUBSCRIPTION_PAYMENTS}
      variables={{ first: 10 }}
      fetchPolicy="network-only"
    >
      {render}
    </Query>
  ),
  paymentsDue: ({ render }) => (
    <Query
      query={FETCH_PAYMENTS_DUE}
      variables={{ first: 10 }}
      fetchPolicy="network-only"
    >
      {render}
    </Query>
  ),
  createUserPayment: ({ render }) => (
    <Mutation
      mutation={CREATE_USER_PAYMENT}
      awaitRefetchQueries
      refetchQueries={[
        { query: FETCH_SUBSCRIPTION_PAYMENTS, variables: { first: 10 } },
        { query: FETCH_PAYMENTS_DUE, variables: { first: 10 } },
      ]}
      onCompleted={() => notify.success({ ...messages.CREATE_USER_PAYMENT.success })}

    >
      {render}
    </Mutation>
  ),
  /* eslint-enable react/prop-types */
};

export const PaymentsScreenConnector = () => (
  <Adopt mapper={mapper}>
    {({
      subscriptions,
      paymentsDue,
      createUserPayment,
    }) => {
      const mappedSubscriptions = mapSubscriptions(subscriptions);
      const mappedPaymentsDue = mapPaymentsDue(paymentsDue);

      return (
        <PaymentsScreen
          subscriptions={mappedSubscriptions}
          paymentsDue={mappedPaymentsDue}
          loadMore={{
            subscriptions: values => pagination.fetchNextPage(subscriptions, 'userPayments', values),
            paymentsDue: values => pagination.fetchNextPage(paymentsDue, 'usersWithDuePayments', values),
          }}
          onSearch={{
            subscriptions: subscriptions.refetch,
            paymentsDue: paymentsDue.refetch,
          }}
          onDateRangeUpdate={subscriptions.refetch}
          onPayment={variables => createUserPayment({ variables })}
        />
      );
    }}
  </Adopt>
);

export default PaymentsScreenConnector;
